import React, { useState, useMemo } from "react";
import { NavLink } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import isAccess from "../../utils/checkAccess";
import "./style.scss";
import arrow_sidebar from "../../assets/images/arrow_sidebar.svg";
import arrowSidebarOff from "../../assets/images/arrowSidebarOff.svg";

const getDecodedToken = () => {
  try {
    const token = localStorage.getItem("token");
    return token ? jwtDecode(JSON.parse(token)) : null;
  } catch {
    return null;
  }
};

const SideBar = () => {
  const [sideBarExpanded, setSideBarExpanded] = useState(false);
  const decodedToken = useMemo(() => getDecodedToken(), []);

  const getViewAccess = (moduleName) => {
    if (!decodedToken) return false;
    const { view } = isAccess(decodedToken.userRole, moduleName);
    return view;
  };

  const navItems = useMemo(
    () => [
      { to: "/Dashboard", label: "Dashboard", icon: "floor" },
      {
        to: "/manageUser",
        label: "User Management",
        icon: "mangeUser",
        access: getViewAccess("User Management"),
      },
      {
        to: "/customer",
        label: "Customer Management",
        icon: "customer",
        access: getViewAccess("Customer Management"),
      },
      { to: "/buildingManagement", label: "Building Management", icon: "proj" },
      {
        to: "/floorManagement",
        label: "Floor Management",
        icon: "floormangement",
        access: getViewAccess("Floor Management"),
      },
      { to: "/device", label: "Device Management", icon: "deviceMangement" },
    ],
    [decodedToken]
  );

  return (
    <div className="SideBar_wrapper">
      <button
        className={`sideBar_excp_btn ${sideBarExpanded ? "on" : "off"}`}
        onClick={() => setSideBarExpanded((prev) => !prev)}
        aria-label="Toggle sidebar"
      >
        <img
          src={sideBarExpanded ? arrow_sidebar : arrowSidebarOff}
          alt="Toggle Sidebar"
        />
      </button>

      <ul
        className={`sideBar_nav_listing ${sideBarExpanded ? "show" : "hide"}`}
        role="navigation"
      >
        {navItems
          .filter((item) => item.access !== false)
          .map(({ to, label, icon }) => (
            <li key={to}>
              <NavLink
                to={to}
                className={({ isActive }) => (isActive ? "active" : "inactive")}
              >
                <span className={icon} aria-hidden="true"></span>
                <span>{label}</span>
              </NavLink>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default SideBar;
